import React, { Component } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip, FormGroup, Label, CustomInput} from 'reactstrap';

import http from "../../../../services/HttpService";
import {Redirect} from "react-router";
import Route from "../../../../Routes";
import swal from "sweetalert2";

import i18next from 'i18next';
import { Translation } from "react-i18next";

import { FilePond, File, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop.js';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginImageCrop, FilePondPluginImageEdit);


import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)

export default class AddIndustry extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    state = {
        name: "",
        updated: false,
        image: [],
        valid: {
            name: false,
            image: false,
        },
        newIndustryID:"",
        active:true,

    };

    constructor(props: Map<any, any>) {
        super(props);
    }

    componentDidUpdate() {
        this.props.onRef(this);
    }

    @autobind
    getData(){
        http.post(`/industries/getLastIndustry`)
            .then(response => response.json())
            .then((data) => {
                this.setState({
                    newIndustryID: data
                });
            });
    }

    @autobind
    addIndustry(event) {
        event.preventDefault();
        const { name, valid, image, active} = this.state;

        if (!valid.name || !valid.image) {
            const list = [];

            !valid.name && list.push("Industry name");
            !valid.image && list.push("Industry image");

            const message = 'Please fill following fields: ' + list.join(', ');
            swal.fire('Failed', message, 'error');

            return;
        }

        const formData = new FormData();
        formData.append("i_name", name);
        formData.append("i_image", image[0] ? image[0].file : null);
        formData.append("i_active", JSON.stringify(active));

        http.withFormData ('POST','/industries/add', formData)
            .then((response: any) => {
                if (response.ok) {
                    swal.fire('Done', 'Partner successfully added.', 'success')
                        .then(() => {
                            this.setState({
                                updated: true
                            });
                        });
                } else {
                    swal.fire('Failed', 'Something went wrong.', 'error');
                }
            })
            .catch((err) => {
                swal.fire('Failed', 'Something went wrong.', 'error');
            });
    }

    @autobind
    changeIndustryName(event) {
        const { valid } = this.state;
        const name = event.target.value;

        if (name == "") {
            valid.name = false;
        } else {
            valid.name = true;
        }

        this.setState({
            name,
            valid,
        });
        this.getData();
    }

    @autobind
    changeImage(files) {
        const { valid } = this.state;
        if (files.length == 0) {
            valid.image = false;
        } else {
            valid.image = true;
        }

        this.setState({
            image: files,
            valid,
        });
    }

    @autobind
    handleActive() {
        this.setState({active: !this.state.active});
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const { name, newIndustryID, updated, image, active} = this.state;

        if (updated) {
            // return <Redirect to={Route.toUrl('dashboard_industry_edit', {industryId: newIndustryID})} />
            return <Redirect to={Route.toUrl('dashboard_industry_all')} />
        }

        return(
            <Container fluid>
                <Row>
                    <Col className="col-sm-12">
                        <h4 className="header-title">Add industry!</h4>
                    </Col>
                </Row>
                <Row>
                    <Col className="dashboard_add_style_block col-sm-offset-3 col-sm-6">
                        <form onSubmit={this.addIndustry}>
                            <Row>
                                <Col className="col-xs-9">
                                    <FormGroup className="mt-4">
                                        <Label for="name" className="dashboard_forms_label">Industry name<sup className="my_sup_class">*</sup></Label>
                                        <Input
                                            type="name" placeholder="Industry name"
                                            className="contact_form_input" id="name"
                                            value={name} onChange={this.changeIndustryName}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col className="col-xs-3 text-center">
                                    <Label for="title" className="dashboard_forms_label">Active-Inactive</Label>
                                    <div>
                                        <input
                                            className="dashboard_featured_cachkbox"
                                            type="checkbox"
                                            onChange={this.handleActive}
                                            defaultChecked={active}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup className="mt-4">
                                        <Label for="image" className="dashboard_forms_label">Image<sup className="my_sup_class">*</sup></Label>
                                        <FilePond
                                            labelIdle={`<span class="filepond--label-action">Image</span>`}
                                            files={image}
                                            allowMultiple={false}
                                            onupdatefiles={this.changeImage}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="text-center">
                                <Button className="dashboard_add_form_button">Add</Button>
                            </div>
                        </form>
                    </Col>
                </Row>
            </Container>
        );

    }
}
